import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const DeleteIcon = (props: Props) => (
  <Svg viewBox='0 0 17 16' fill='none' {...props}>
    <Path
      d='M2.5 4.00004H3.83333M3.83333 4.00004H14.5M3.83333 4.00004L3.83333 13.3334C3.83333 13.687 3.97381 14.0261 4.22386 14.2762C4.47391 14.5262 4.81304 14.6667 5.16667 14.6667H11.8333C12.187 14.6667 12.5261 14.5262 12.7761 14.2762C13.0262 14.0261 13.1667 13.687 13.1667 13.3334V4.00004M5.83333 4.00004V2.66671C5.83333 2.31309 5.97381 1.97395 6.22386 1.7239C6.47391 1.47385 6.81304 1.33337 7.16667 1.33337H9.83333C10.187 1.33337 10.5261 1.47385 10.7761 1.7239C11.0262 1.97395 11.1667 2.31309 11.1667 2.66671V4.00004M7.16667 7.33337V11.3334M9.83333 7.33337V11.3334'
      stroke='#FE5000'
      strokeWidth={1.6}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
